import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import UserHeader from "components/Headers/UserHeader.js";
import { useState, useEffect } from "react";
import ReactModal from "react-modal";
import axios from "axios";

const CrearLista = () => {
  const [postNombre, setPostNombre] = useState("");
  const [postOrden, setPostOrden] = useState("");
  const [ordenes, setOrdenes] = useState([]); // Estado para las opciones del dropdown

  const [modalIsOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Obtener las opciones del dropdown desde el API
    axios
      .get(
        "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerTipoOrdenes",
      ) // Reemplaza con la URL correcta de tu API
      .then((response) => {
        setOrdenes(response.data); // Asumiendo que la respuesta tiene el formato correcto
      })
      .catch((error) => {
        console.error("Error al obtener opciones:", error);
      });
  }, []);

  const handleOpenModalTest = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const postData = (e) => {
    e.preventDefault();
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://inspecciongnvback-dev.azurewebsites.net/api/v1/CrearLista",
      data: {
        nombre: postNombre,
        tipoOrdenSerivicioId: postOrden,
      },
    })
      .then((response) => {
        console.log(response.data);
        alert("Creada con éxito!");
        window.location.reload("/");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear: " + error);
      });
  };

  return (
    <>
      {/* Page content */}
      <button
        variant="contained"
        className="btn btn-primary btn-lg"
        color="primary"
        onClick={handleOpenModalTest}
      >
        Nueva Lista
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-1" xl="12">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">My account</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">NOMBRE</h6>
                    <div className="pl-lg-4">
                      <FormGroup>
                        <Input
                          className="form-control-alternative"
                          id="input-postal-code"
                          placeholder=""
                          type="text"
                          onChange={(e) => setPostNombre(e.target.value)}
                        />
                      </FormGroup>
                      <h6 className="heading-small text-muted mb-4">
                        ORDEN DE SERVICO
                      </h6>
                      <FormGroup>
                        <Input
                          className="form-control-alternative"
                          id="input-order-service"
                          type="select"
                          onChange={(e) => setPostOrden(e.target.value)}
                        >
                          <option value="">Seleccione una opción</option>
                          {ordenes.map((orden) => (
                            <option key={orden.id} value={orden.id}>
                              {orden.nombre}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                      <button
                        className="btn btn-primary btn-lg"
                        color="primary"
                        onClick={postData}
                      >
                        ENVIAR
                      </button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </ReactModal>
    </>
  );
};

export default CrearLista;
